import React from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '@pearsontechnology/aero-components';

import {
  ErrorPageWrapper,
  ErrorPageContent,
  ErrorPageIcon,
  ErrorPageTitle,
  ErrorPageMessage,
} from './styles';

export default function ErrorPage({ icon, title, message, children }) {
  return (
    <ErrorPageWrapper>
      <ErrorPageContent>
        {!!icon && <ErrorPageIcon><SVGIcon icon={icon} /></ErrorPageIcon>}
        <ErrorPageTitle>{ title }</ErrorPageTitle>
        {!!message && <ErrorPageMessage>{ message }</ErrorPageMessage>}
        {children}
      </ErrorPageContent>
    </ErrorPageWrapper>
  );
}

ErrorPage.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.element,
};
